import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { Toaster } from "./components/ui/toaster";

import reportWebVitals from "./reportWebVitals";
import App from "./App";
import "./index.css";
import { store } from "./features/store";
import { instance } from "./axios/axios";
import {
  PREVIEW_MODE,
  installPreviewFetch,
  installPreviewAxios,
} from "./features/preview/previewMode";
import PreviewModeBanner from "./components/PreviewModeBanner";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

// Preview builds only: short-circuit every BFF call to a local fixture so no
// page hangs on a request the mock session can't satisfy. Must run before the
// first render so the App-mount session check is already intercepted. No-op in
// prod (PREVIEW_MODE is false → these compile out).
if (PREVIEW_MODE) {
  installPreviewFetch();
  installPreviewAxios(instance);
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <>
    <Toaster />
    {PREVIEW_MODE && <PreviewModeBanner />}
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </>
);

// Register the push-only service worker (public/service-worker.js). It caches
// nothing (no fetch handler) so it can't re-pin devices to a stale portal — the
// old app-shell stale-deploy bug stays fixed — but it stays registered so the
// app can receive web push notifications (feature #11, layer 3).
serviceWorkerRegistration.register();

// Make clicking anywhere on a date/datetime input open the native picker overlay,
// not just the small calendar icon on the right side. Applies globally to all
// type="date" and type="datetime-local" inputs across the portal.
document.addEventListener('click', (e) => {
  const t = e.target;
  if (
    t instanceof HTMLInputElement &&
    (t.type === 'date' || t.type === 'datetime-local') &&
    !t.disabled &&
    !t.readOnly
  ) {
    try { t.showPicker?.(); } catch { /* ignore: unavailable in some browsers */ }
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
